<template>
  <button @click="copyUrl()" type="button" class="w3-button w3-text-theme">
    <font-awesome-icon :icon="['fal', 'share-square']" /> Share
  </button>
</template>

<script>
  import ShareButton from "./ShareButton.ts";

  export default ShareButton
</script>
